import React from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player/lazy';
import styled from 'styled-components';

import { hasWindow } from '../utils';

const baseVideoUrl = 'https://dt86prc7k97an.cloudfront.net';
const isSafari =
  hasWindow() && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const Player = styled(ReactPlayer)`
  video {
    object-fit: cover;
    border-radius: 5px;
  }
`;

const VideoPlayerAWS = ({ videoSource }) => {
  const url = `${baseVideoUrl}/${videoSource}/playlist.m3u8`;
  const poster = `${baseVideoUrl}/${videoSource}/poster.jpg`;

  return (
    <Player
      url={url}
      config={{
        file: {
          forceHLS: !isSafari,
          forceVideo: true,
          hlsVersion: '0.14.16',
          attributes: {
            disablePictureInPicture: true,
            poster,
          },
        },
      }}
      width="100%"
      height="100%"
      onError={(_name, err) => {
        // eslint-disable-next-line
        console.log(err);
      }}
      playsinline
      controls
    />
  );
};

VideoPlayerAWS.propTypes = {
  videoSource: PropTypes.string.isRequired,
};

export default VideoPlayerAWS;
